// components/admin/AdminLayout.js
import React from 'react';
import { Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import AdminNavbar from './AdminNavbar';

const AdminLayout = ({ children }) => {
  return (
    <>
      <div className="admin-layout">
        <Sidebar />
        <div className="admin-content">
          <AdminNavbar />
          <Container fluid className="py-3 px-3">
            {children}
          </Container>
        </div>
      </div>
    
    </>
  );
};

export default AdminLayout;